import {
  Hotel,
  UtensilsCrossed,
  WashingMachine,
  Factory,
  HeartPulse,
  ShoppingCart,
  Store,
  Building2,
  Warehouse,
  ShoppingBag,
  Building,
  Server,
} from "lucide-react";
import { Container, Reveal } from "@/components/Reveal";

const INDUSTRIES = [
  { label: "Hotels", Icon: Hotel },
  { label: "Restaurants", Icon: UtensilsCrossed },
  { label: "Laundromats", Icon: WashingMachine },
  { label: "Manufacturing", Icon: Factory },
  { label: "Hospitals", Icon: HeartPulse },
  { label: "Grocery Stores", Icon: ShoppingCart },
  { label: "Convenience Stores", Icon: Store },
  { label: "Office Buildings", Icon: Building2 },
  { label: "Warehouses", Icon: Warehouse },
  { label: "Retail", Icon: ShoppingBag },
  { label: "Commercial Real Estate", Icon: Building },
  { label: "Data Centers", Icon: Server },
];

export default function WhoWeServe() {
  return (
    <section className="bg-ice py-20 md:py-24" data-testid="who-we-serve">
      <Container>
        <div className="max-w-2xl">
          <p className="overline text-electric">Who We Serve</p>
          <h2 className="mt-4 font-heading text-3xl font-semibold tracking-tight text-navy sm:text-4xl">
            We work with all kinds of commercial businesses.
          </h2>
          <p className="mt-4 text-lg leading-relaxed text-slatey">
            From a single location to a nationwide portfolio, we help businesses across
            many industries understand their energy options and make better decisions.
          </p>
        </div>

        <div className="mt-12 grid grid-cols-2 border-l border-t border-line sm:grid-cols-3 lg:grid-cols-4 xl:grid-cols-6">
          {INDUSTRIES.map(({ label, Icon }, i) => (
            <Reveal
              key={label}
              delay={(i % 6) * 0.05}
              className="border-b border-r border-line"
            >
              <div
                data-testid={`serve-${label.toLowerCase().replace(/\s+/g, "-")}`}
                className="group flex h-full flex-col items-center justify-center gap-3 bg-ice px-4 py-8 text-center transition-colors hover:bg-white"
              >
                <Icon className="h-7 w-7 text-electric transition-transform duration-300 group-hover:scale-110" />
                <span className="text-sm font-medium text-navy">{label}</span>
              </div>
            </Reveal>
          ))}
        </div>
      </Container>
    </section>
  );
}
